export default __webpack_public_path__ + "static/media/SIW400H_KT_W20.d33fcee8.webp";